import { object, string } from 'yup'
import { t } from 'ttag'

import { LANGUAGE_FIELD, EMAIL_FIELD, NAME_FIELD, PHONE_FIELD } from './model'

export const getSchema = () =>
  object().shape({
    [NAME_FIELD]: string().required(t`This field cannot be empty.`),
    [EMAIL_FIELD]: string()
      .email(t`Invalid email address.`)
      .required(t`This field cannot be empty.`),
    [PHONE_FIELD]: string().optional(),
    [LANGUAGE_FIELD]: object()
      .shape({ label: string(), value: string() })
      .required(t`This field cannot be empty.`),
  })
